const __fetchPlans = {
  method: "GET",
  url: "sim/tmobilej/plans",
};

const __fetchPlanDetails = (id) => ({
  method: "GET",
  url: `sim/tmobilej/plans/${id}`,
});

const __updatePlanDetails = (id) => ({
  method: "PUT",
  url: `sim/tmobilej/plans/${id}`,
});

const __createPlan = {
  method: "POST",
  url: `sim/tmobilej/plans`,
};

export { __fetchPlans, __fetchPlanDetails, __updatePlanDetails, __createPlan };

